<template>
  <tr :class="{ empty: !user.id }">
    <td @click="moveToUserDetail"><div class="text-ellipsis">{{ name }}</div></td>
    <td @click="moveToUserDetail"><div class="text-ellipsis">{{ occupationName }}</div></td>
    <td>
      <awaiting-candidate-table-action :user="user" :state="state" :entityId="entityId" v-if="user.id"/>
    </td>
  </tr>
</template>

<script>
import AwaitingCandidateTableAction from './AwaitingCandidateTableAction'

export default {
  name: "AwaitingCandidateTableRow",
  props: ['user', 'state', 'entityId'],
  components: {
    AwaitingCandidateTableAction
  },
  computed: {
    occupationName(){
      let occupation =this.user.occupations
      occupation = Array.from(new Set(occupation.map(a => a.id)))
        .map(id => {
          return occupation.find(a => a.id === id)
        })
      return occupation.map(occupation => occupation['name']).join(', ');
    },
    firstNameInitial(){
      return this.user.first_name && this.user.first_name.trim() != '' ? `${this.user.first_name.trim().charAt(0)}.` : ""
    },
    name() {
      return [this.user.last_name, this.firstNameInitial].join(' ').trim()
    }
  },
  methods: {
    moveToUserDetail() {
      this.$router.push({ name: 'EditUser', params: { entity_id: this.entityId, user_id: this.user.id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/manager/AwaitingCandidateTableRow.vue